import { Component, OnInit, Input } from "@angular/core";
import { ClassroomAttendanceService } from "./../../classroomAttendance.service";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { VoidTransactionService } from "./voidTransaction.service";

@Component({
	selector: "caass-classroom-classroomAttendance-Point-VoidTransaction",
	templateUrl: "./VoidTransaction.component.html",
	providers: [VoidTransactionService],
})
export class ClassroomAttendancePointVoidTransactionComponent {
	@Input() personid: any;
	@Input() schoolID: any;
	lastTransactionList: any = [];
	PersonID;
	SchoolID;
	transactionID;
	hideVoidC = false;
	isVoid: boolean;
	showTransaction = false;
	constructor(private classroomService: ClassroomAttendanceService, private voidTransactionService: VoidTransactionService) {}

	cancelClick() {
		this.classroomService.cancelEdit();
	}
	ngOnInit() {
		this.PersonID = this.personid;
		this.SchoolID = this.schoolID;
		this.LastTransactionGetList();
	}
	FadeOutLink() {
		setTimeout(() => {
			this.hideVoidC = false;
		}, 6000);
	}
	private LastTransactionGetList() {
		var result = this.voidTransactionService.LastTransactionGet(this.PersonID, this.SchoolID);

		result.subscribe(
			(response: any) => {
				this.lastTransactionList = response;

				if (this.lastTransactionList.length > 0) {
					this.isVoid = this.lastTransactionList[0].IsVoid;

					this.showTransaction = true;
					this.hideVoidC == false;
				} else {
					this.showTransaction = false;
					this.hideVoidC = true;
					this.FadeOutLink();
				}

				if (this.lastTransactionList.length > 1) {
					this.lastTransactionList.unshift({});
				}
			},

			(error) => {
				error;
			}
		);
	}

	submitClick() {
		this.transactionID = this.lastTransactionList[0].PointsTransactionID;

		var result = this.voidTransactionService.TransactionVoid(this.transactionID);

		result.subscribe(
			(response: any) => {
				this.classroomService.LoadData();
				this.transactionID = 0;
			},
			(error) => {}
		);
		this.lastTransactionList = [];
		this.cancelClick();
	}
}
